import type { AiAgentsRole, FeedbackStatus, FeedbackVerdict } from '@/dto'

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  received: 'Recebido',
  triaging: 'Em triagem',
  triaged: 'Triado',
  in_review: 'Em revisão',
  fixing: 'Em correção',
  pr_open: 'PR aberto',
  resolved: 'Resolvido',
  dismissed: 'Descartado',
}

export const FEEDBACK_VERDICT_LABELS: Record<FeedbackVerdict, string> = {
  procedente_bug: 'Bug no algoritmo',
  config: 'Configuração do CD',
  forced: 'Forçado pela capacidade',
  unfounded: 'Improcedente',
}

export const FEEDBACK_VERDICT_HINTS: Record<FeedbackVerdict, string> = {
  procedente_bug: 'O algoritmo errou e dá para corrigir no código.',
  config: 'O resultado segue a configuração; o ajuste é no setup do CD.',
  forced: 'Não havia jogada melhor com o espaço disponível.',
  unfounded: 'A paletização está certa; o feedback não procede.',
}

const ROLE_LEVEL: Record<AiAgentsRole, number> = { none: 0, viewer: 1, reviewer: 2, admin: 3 }

export function aiAgentsLevel(role: AiAgentsRole | string | null | undefined): number {
  return ROLE_LEVEL[(role || 'none') as AiAgentsRole] ?? 0
}

export function statusOptions() {
  return Object.entries(FEEDBACK_STATUS_LABELS).map(([value, label]) => ({ value, label }))
}

export function verdictOptions(includeNone = false) {
  const list = Object.entries(FEEDBACK_VERDICT_LABELS).map(([value, label]) => ({ value, label }))
  return includeNone ? [{ value: 'none', label: 'Sem veredito' }, ...list] : list
}
